import { StyledAdminDropdown } from './styles';

interface IAdminDropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export const AdminDropdown = ({ children, onBlur, onMouseLeave }: IAdminDropdownProps) => {
  return (
    <StyledAdminDropdown onBlur={onBlur} onMouseLeave={onMouseLeave}>
      {children}
    </StyledAdminDropdown>
  );
};
